import Icon from '../components/Icon.vue'

Icon.register({
  hamburger: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 256c26.5 0 48 21.5 48 48s-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48s21.5-48 48-48h416zM480 384c8.8 0 16 7.2 16 16v16c0 35.3-28.7 64-64 64h-352c-35.3 0-64-28.7-64-64v-16c0-8.8 7.2-16 16-16h448zM58.6 224c-34.6 0-54.6-43.9-34.8-75.9 40.2-64.9 128.6-116 232.2-116.1 103.5 0.1 192 51.2 232.2 116.1 19.8 32-0.3 75.9-34.8 75.9h-394.7zM384 112c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zM256 80c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zM128 112c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hamburger.js
// module id = 1418
// module chunks = 0